import script from "./prePrint.vue?vue&type=script&setup=true&lang=js"
export * from "./prePrint.vue?vue&type=script&setup=true&lang=js"

import "./prePrint.vue?vue&type=style&index=0&id=77c66988&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77c66988"]])

export default __exports__